const Paths = {
  ROOT: '/',
  HOME: '/home',
  ABOUT_US: '/about-us',
  BENEFITS: '/benefits',
  BLOG: '/blog',
  PREPAID_CARDS: '/prepaidcards',
  CASHBACK: '/cashback',
  CONTACT_US: '/contact-us',
  CONTACT: '/contact',
  CUSTOMERS: '/customers',
  DISCOUNTS: '/discounts',
  EMPLOYEES: '/employees',
  FAQS: '/FAQs',
  HOW_IT_WORKS: '/how-it-works',
  LEGAL_AGREEMENTS: '/masterservicesagreement-termsandconditions',
  MEDIA: '/media',
  PAYROLL_CARDS: '/payrollcards',
  REMITTANCES: '/remittances',
  SIGNUP: '/signup',
  TIPS: '/tips',
  TRAVEL: '/travel',
  WAGE_ACCESS: '/wage-access'
}

export default Paths
